import { Button, Flex, TextField } from "@radix-ui/themes";

interface Props {
  /** Where the emailed link lands them, signed in. A path on this site. */
  returnTo: string;
  buttonLabel?: string;
}

/**
 * "Email me a link": the way in for a signed-out visitor, right where the
 * thing they want to do is. Signing in and signing up are the same move, so
 * it never asks which they are (SignInLinksController). A real form post,
 * not an Inertia visit: it lands on the plain "Check your email" page.
 */
export default function SignInLinkForm({
  returnTo,
  buttonLabel = "Email me a link",
}: Props) {
  const csrfToken =
    document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
      ?.content ?? "";

  return (
    <form method="post" action="/sign_in_link">
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      <input type="hidden" name="return_to" value={returnTo} />
      <Flex gap="2" direction={{ initial: "column", sm: "row" }}>
        <TextField.Root
          type="email"
          name="email"
          required
          autoComplete="email"
          placeholder="you@example.com"
          size="3"
          style={{ flexGrow: 1 }}
        />
        <Button type="submit" size="3">
          {buttonLabel}
        </Button>
      </Flex>
    </form>
  );
}
